/* global axios */

export default {
  login: params =>
    axios.post('/users/sign_in', {
      user: params,
    }),
  logout: () =>
    axios.delete('/users/sign_out', {
      data: {}, // Workaround for axios bug https://github.com/mzabriskie/axios/issues/362
    }),
}



// WEBPACK FOOTER //
// ./src/models/Session.js